import { useEffect, useRef } from 'react'

let timeoutId: NodeJS.Timeout

/**
 * @deprecated
 * @param onWindowResize
 * @param debounce
 */
export function useOnWindowResize(onWindowResize: () => void, debounce = 0): void {
  const callback = useRef(onWindowResize).current

  useEffect(() => {
    callback()

    window.addEventListener('resize', () => {
      if (debounce) {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(callback, debounce)
      } else {
        callback()
      }
    })

    return (): void => window.removeEventListener('resize', callback)
  }, [callback, debounce])
}
